export const TITLE = "Select channels and set budget";
export const TITLE_BUDGET_CHECK = "Channel and budget recommendation";
export const SUBTITLE =
  "We have calculated the appropriate budget for the selected parameters and made a selection of channels.";
export const SUBTITLE_BUDGET_CHECK =
  "We recommend the following budget and recruiting channels for the parameters entered.";
export const FALLBACK_CAMPAIGN_COUNT = 1200;

const DEFAULT_MIN_CAMPAIGN_CHANNELS = parseInt(process.env.DEFAULT_MIN_CAMPAIGN_CHANNELS, 10) || 1;
const DEFAULT_MAX_CAMPAIGN_CHANNELS = parseInt(process.env.DEFAULT_MAX_CAMPAIGN_CHANNELS, 10) || 4;

export const MIN_CAMPAIGN_CHANNELS =
  parseInt(process.env.MIN_CAMPAIGN_CHANNELS, 10) || DEFAULT_MIN_CAMPAIGN_CHANNELS;
export const MAX_CAMPAIGN_CHANNELS =
  parseInt(process.env.MAX_CAMPAIGN_CHANNELS, 10) || DEFAULT_MAX_CAMPAIGN_CHANNELS;
